import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useLogger } from 'Src/feature/context-logger/useLogger';
import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';
import { useOperator } from 'Src/feature/operator/useOperator';
import { useToast } from 'Src/feature/toasts/useToast';
import useRoute from 'Src/routes/useRoute';

const sectionId = 'POSClockout';

/**
 * @description - route component used to clock out the user
 */
const POSClockout: React.FC = () => {
  const { t } = useTranslation();
  const log = useLogger().getSubLogger({ name: sectionId });
  const toast = useToast({ persist: true });
  const { crumbs, navigate } = useRoute();
  const { setCurrentOperator } = useCurrentOperator();
  const operatorClockOut = useOperator.mutate.clockOut();

  const doClockOut = () => {
    operatorClockOut.mutate(undefined, {
      onError: (err) => {
        log.error('doClockOut', err);
        toast.show.serviceError(err, { title: t('clockOut.error.title') });
        navigate(-1);
      },
      onSuccess: () => {
        setCurrentOperator(undefined);
        navigate(crumbs.pos.main.path);
      }
    });
  };

  useEffect(() => {
    void doClockOut();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default POSClockout;
